import {
    MANAGER_NOTES_ANSWER_ERROR,
    MANAGER_NOTES_ANSWER_LOADING,
    MANAGER_NOTES_ANSWER_SUCCESS,
    MANAGER_NOTES_FETCH_ERROR,
    MANAGER_NOTES_FETCH_LOADING,
    MANAGER_NOTES_FETCH_SUCCESS,
    ReduxAction,
} from '../actions/managerNotesTypes';

const managerNotesState = (
    state: any = { questions: [], answers: [] },
    action: ReduxAction,
): any => {
    switch (action.type) {
        case MANAGER_NOTES_FETCH_SUCCESS:
        case MANAGER_NOTES_FETCH_ERROR:
        case MANAGER_NOTES_FETCH_LOADING:
        case MANAGER_NOTES_ANSWER_ERROR:
        case MANAGER_NOTES_ANSWER_LOADING:
        case MANAGER_NOTES_ANSWER_SUCCESS:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default managerNotesState;
